import axios from "axios"

const getToken = () => localStorage.getItem("access_token");

export const baseGetRequest = async ({
    url
}:{
    url:string
}) => {
    try {
        let token = getToken();
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL + url}`, {
            headers: {
                Authorization : `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const basePostRequest = async ({
    url,
    body
}:{
    url:string,
    body:{ [key:string]: any}
}) => {

    try {
        let token = getToken();
        //console.log("REQUEST TOKEN: ", token);
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL + url}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};